import React, { useState, } from 'react';
import {
    AppBar,
    Button,
    GridList,
    GridListTile,
    Toolbar,
    Tooltip,
    Typography,
    makeStyles,
    useTheme,
    useMediaQuery,
} from '@material-ui/core';
import sampleImages from './sample';

const useStyles = makeStyles((theme)=> ({
    root: {
        position: 'relative',
        width: '100%',
        height: '100vh',
        display: 'block',
    },
    imageContainer: {
        margin: '0 auto',
        padding: '0 50px',
        textAlign: 'center',
        '& img': {
            maxWidth: '100%',
            maxHeight: '100%',
        },
    },
    gridList: {
        // Promote the list into its own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    heading: {
        flexGrow: 1,
    },
    hiddenInput: {
        display: 'none',
    }
}));

export default function ImageProof(props) {
    const classes = useStyles();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const [ imageList, setImageList ] = useState(sampleImages);
    const [ importedFileName, setImportedFileName ] = useState(null);
    const onFileSelect = (e)=> {
        if(e.target && e.target.files && e.target.files[0]) {
            const selectedFile = e.target.files[0];
            setImportedFileName(selectedFile.name);
            const fileReader = new FileReader();
            fileReader.readAsText(selectedFile);
            fileReader.onload = ()=> {
                try {
                    const parsedFile = JSON.parse(fileReader.result);
                    setImageList(parsedFile.map(({ url } = {})=> url));
                } catch (e) {
                    alert(`Error parsing ${selectedFile.name}. See console for detailed error`);
                    console.error('Error parsing file', e);
                }
            }
        }
    }
    return (
        <div className={classes.root} id="templateRoot">
            <AppBar position="fixed">
              <Toolbar>
                <Typography variant="h5" className={classes.heading}>Image Proof</Typography>

                <input
                    accept="text/json"
                    id="contained-button-file"
                    type="file"
                    onChange={onFileSelect}
                    className={classes.hiddenInput}
                />
                {importedFileName && (<Typography variant="body2">{importedFileName}&nbsp;&nbsp;</Typography>)}
                <label htmlFor="contained-button-file">
                    <Tooltip title="Select a JSON file with an array of objects where object.url is the image to show in the preview." arrow>
                        <Button variant="contained"
                            color="secondary"
                            component="span"
                        >Import JSON</Button>
                    </Tooltip>
                </label>
              </Toolbar>
            </AppBar>

            {/* Extra Toolbar rendered to make
                room for fixed header */}
            <Toolbar />
            <div className={classes.imageContainer}>
                <GridList className={classes.gridList}
                    cols={isXs ? 1 : 2}
                    cellHeight="auto"
                    spacing={theme.spacing(4)}
                >
                    {imageList.map((url, i)=> {
                        return (
                            <GridListTile key={url + i}>
                                <img src={url} alt="Preview" />
                            </GridListTile>
                        );
                    })}
                </GridList>
           </div>
        </div>
    );
}